export const UPDATE_DATE_RANGE_SELECTION = "UPDATE_DATE_RANGE_SELECTION";

export function updateDateRangeSelection(range) {
  return {
    type: UPDATE_DATE_RANGE_SELECTION,
    payload: range,
  };
}
